import { ISubscriptionPaymentMethods, ISubscriptionTransaction } from '@/helpers/subscription';
import { IUser, IUserInformation } from '@/helpers/user';
import { IPaginationResult } from '@/helpers/utils';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'admin', namespaced: true })
export default class AdminModule extends VuexModule {
  users: IPaginationResult<IUser[]> = {
    total: 0,
    prev_page_url: null,
    next_page_url: null,
    current_page: 0,
    data: [],
    per_page: 2,
  };

  stats: IPaginationResult<any[]> = {
    total: 0,
    prev_page_url: null,
    next_page_url: null,
    current_page: 0,
    data: [],
    per_page: 2,
  };

  selectedUserInformation: IUserInformation = {
    user: null,
    transactions: [],
    paymentMethods: []
  };

  availableFlags: string[] = [
    'flag_test',
  ];

  @Action
  async loadUsers(users: IPaginationResult<IUser[]>) {
    this.context.commit('SET_USERS', users);
  }

  @Mutation
  SET_USERS(users: IPaginationResult<IUser[]>) {
    this.users = users;
  }

  @Action
  async loadStats(users: IPaginationResult<any[]>) {
    this.context.commit('SET_STATS', users);
  }

  @Mutation
  SET_STATS(stats: IPaginationResult<any[]>) {
    this.stats = stats;
  }

  @Action
  async setSelectedUser(selectedUser: IUser) {
    this.context.commit('SET_SELECTED_USER', selectedUser);
  }

  @Action
  async setSelectedUserSubscriptions(subscriptions) {
    this.context.commit('SET_SELECTED_USER_SUBSCRIPTIONS', subscriptions);
  }

  @Action
  async setSelectedUserTransactions(transactions: ISubscriptionTransaction[]) {
    this.context.commit('SET_SELECTED_USER_TRANSACTIONS', transactions);
  }

  @Action
  async setSelectedUserPaymentMethods(paymentMethods: ISubscriptionPaymentMethods[]) {
    this.context.commit('SET_SELECTED_USER_PAYMENT_METHODS', paymentMethods);
  }

  @Action
  async clearSelectedUser() {
    this.context.commit('SET_SELECTED_USER', null);
  }

  @Action
  async updateUser(user: IUser) {
    this.context.commit('SET_SELECTED_USER', null);
  }

  @Mutation
  SET_SELECTED_USER(selectedUser: IUser) {
    this.selectedUserInformation.user = selectedUser;
  }

  @Mutation
  SET_SELECTED_USER_SUBSCRIPTIONS(subscriptions) {
    this.selectedUserInformation.user.subscriptions = subscriptions;
  }

  @Mutation
  SET_SELECTED_USER_TRANSACTIONS(transactions: ISubscriptionTransaction[]) {
    this.selectedUserInformation.transactions = transactions;
  }

  @Mutation
  SET_SELECTED_USER_PAYMENT_METHODS(paymentMethods: ISubscriptionPaymentMethods[]) {
    this.selectedUserInformation.paymentMethods = paymentMethods;
  }
}
